<template>
  <card-template-v2 class="common-dashboard-card">
    <template #header>
      <div class="flex-row flex__between">
        <slot name="header"></slot>
        <el-tooltip v-if="!disableViewMore" content="Xem thêm" placement="top">
          <i
            class="fas fa-arrow-right color__white font-size__large clickable "
            @click="viewMore"
          ></i>
        </el-tooltip>
      </div>
    </template>

    <template #body>
      <VuePerfectScrollbar class="scroll-area">
        <template v-if="isDataFound">
          <slot name="body"></slot>
        </template>
        <div v-else class="flex-row flex__center">
          <i
            class="fas fa-ban color__silver font-size__larger margin-right-10"
          ></i>
          <span class="font-size__medium font-weight__bold opacity-50"
          >Không có dữ liệu
          </span
          >
        </div>
      </VuePerfectScrollbar>
    </template>
  </card-template-v2>
</template>
<script>
  import CardTemplateV2 from "./card-template-v2";

  export default {
    name: "common-dashboard-card-template",
    props: ["isDataFound", "disableViewMore"],
    components: {
      CardTemplateV2,
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    methods: {
      viewMore() {
        this.$emit('viewMore');
      }
    }
  };
</script>

<style scoped>
  .common-dashboard-card {
    /* height: 300px; */
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/layout/common-dashboard-card-template.vue